import script from "./NotesView.vue?vue&type=script&setup=true&lang=js"
export * from "./NotesView.vue?vue&type=script&setup=true&lang=js"

import "./NotesView.vue?vue&type=style&index=0&id=5f99ddb6&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5f99ddb6"]])

export default __exports__